import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { useApp } from './store';
export function MustReads() {
  const {
    mustReads
  } = useApp();
  if (mustReads.length === 0) return null;
  return <section aria-label="Must reads" data-id="element-186">
      <div className="flex items-center justify-between mb-3" data-id="element-187">
        <h3 className="text-lg font-serif font-bold text-navy-900" data-id="element-188">
          Must Reads
        </h3>
        <Link to="/news" className="text-xs font-semibold text-gold-600 hover:text-gold-700 uppercase tracking-wide" data-id="element-189">
          View all
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-190">
        {mustReads.map((item, i) => {
        const Icon = item.icon;
        return <motion.button key={item.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="text-left bg-white rounded-xl border border-navy-100 p-4 hover:border-gold-400 hover:shadow-sm transition-all group" data-id="element-191">
              <div className="w-10 h-10 rounded-lg bg-navy-50 flex items-center justify-center text-navy-600 mb-3 group-hover:bg-gold-500 group-hover:text-navy-900 transition-colors" data-id="element-192">
                {Icon ? <Icon className="w-5 h-5" data-id="element-193" /> : null}
              </div>
              <p className="text-[0.7rem] font-bold uppercase tracking-wide text-navy-400 mb-1" data-id="element-194">
                {item.category}
              </p>
              <p className="text-sm font-semibold text-navy-900 leading-snug mb-3" data-id="element-195">
                {item.title}
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-gold-600" data-id="element-196">
                {item.due} <ChevronRight className="w-3 h-3" data-id="element-197" />
              </span>
            </motion.button>;
      })}
      </div>
    </section>;
}